import React from 'react'
import Alert from 'react-bootstrap/Alert'
import Badge from 'react-bootstrap/Badge'
import Button from 'react-bootstrap/Button'
import Card from 'react-bootstrap/Card'

export default function Demo() {
  return (
    <div>
      <h1>
        Asset Panda Primary<Badge variant="primary">PWA</Badge>
      </h1>
      <Alert variant="primary">This is an alert!</Alert>
      <Button variant="primary">I'm a button!</Button>
      <Button variant="outline-primary">I'm an outline button!</Button>
      <br />
      <br />
      <Card>
        <Card.Header>PWA</Card.Header>
        <Card.Body>
          <Card.Title>Special panda</Card.Title>
          <Card.Text>This is a demo of the card component.</Card.Text>
          <Button variant="primary">Go somewhere</Button>
        </Card.Body>
      </Card>
      <br />
      <br />
      <br />
      <h1>
        Asset Panda Secondary color<Badge variant="secondary">PWA</Badge>
      </h1>
      <Alert variant="secondary">This is an alert!</Alert>
      <Button variant="secondary">I'm a button!</Button>
      <Button variant="outline-secondary">I'm an outline button!</Button>
      <br />
      <br />
      <Card>
        <Card.Header>PWA</Card.Header>
        <Card.Body>
          <Card.Title>Special panda</Card.Title>
          <Card.Text>This is a demo of the card component.</Card.Text>
          <Button variant="secondary">Go somewhere</Button>
        </Card.Body>
      </Card>
    </div>
  )
}
